import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Modal, useModal } from 'cat-ecommerce-alloy';
import { setConflictConfirmationFlag } from '@app/store/account/actions';
import useConflictNotes from '../../hooks/useConflictNotes';
import ExceptionFeedback from '@app/components/common/Exception/ExceptionFeedback';
import { FEEDBACK_TYPES } from '@app/constants/errorConstants';
import InfoText from '../../../InfoText';
import ModalButtonCTA from '../../buttons/ModalButtonCTA';

const ConfirmationModal = () => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const { close, isOpen, open } = useModal();
  const { onCloseDispatch, onClickOpenResolutionModal, confirmationModalFlag } =
    useConflictNotes();
  useEffect(() => {
    if (confirmationModalFlag) {
      open();
    }
  }, [dispatch, open, confirmationModalFlag]);
  const onModalClose = val => {
    const payloadData = {
      isOpen: false
    };
    dispatch(setConflictConfirmationFlag(payloadData));
    if (val) {
      onCloseDispatch(close);
    }
    close();
  };
  const openResolutionModal = () => {
    onClickOpenResolutionModal();
  };
  const className = 'u-color--DarkGray u-fs--16 my-3';

  const confirmationTexts = [
    {
      title: t('MERGE_MESSAGE_CONFIRMATION'),
      className: className,
      id: 1
    },
    {
      title: t('MERGE_CONFLICT_MESSAGE'),
      className: className,
      id: 2
    }
  ];

  return (
    <div>
      <Modal
        close={() => onModalClose(false)}
        isOpen={isOpen}
        title={t('MERGING_NOTE')}
      >
        <div>
          <InfoText data={confirmationTexts} />
          <ExceptionFeedback
            className="mb-3"
            preventScroll
            type={FEEDBACK_TYPES.WARNING}
          >
            <p className="u-color--DarkGray">{t('MERGE_OPTION')}</p>
          </ExceptionFeedback>
          <div className="d-flex flex-md-row-reverse flex-column mt-3">
            <ModalButtonCTA
              btnTitle={t('YES')}
              btnType="primary"
              onClick={openResolutionModal}
            />
            <ModalButtonCTA
              btnTitle={t('NO')}
              btnType="ghost"
              onClick={() => onModalClose(true)}
              className="mt-md-0 mt-2 me-0 me-md-0"
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};
export default ConfirmationModal;
